import { render } from "./imageMagnify.vue?vue&type=template&id=5f5edb79"
import script from "./imageMagnify.vue?vue&type=script&lang=js"
export * from "./imageMagnify.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__